export default "__VITE_ASSET__527958fa__"